import { type FC, type ReactNode } from 'react'
import classNames from 'classnames'

interface FormHintProps {
  id?: string
  className?: string
  children: ReactNode
}

export const FormHint: FC<FormHintProps> = ({ id, className, children }) => (
  <span id={id} className={classNames('d-block paragraph-small fw-normal zocks-text-gray-700', className)}>
    {children}
  </span>
)
